import { render } from "./turnover.vue?vue&type=template&id=af6d7158"
import script from "./turnover.vue?vue&type=script&lang=js"
export * from "./turnover.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__